
export const isFunction = func => toString.call( func ) === "[object Function]";

export const isObject = obj => toString.call( obj ) === "[object Object]";

export const addZeroIfNeed = num => +num > 9 ? num : `0${ num }`;

export const replaceSpacesInUrl = url => url.replace(/\s/g, "%20");

export const isNumber = num => toString.call( num ) === "[object Number]" && !isNaN( num );

export const loadScript = options => {
	
	if ( !options.src ) return;
	if ( document.getElementById( options.id )) return;

	const script = document.createElement('script');
	script.id  = options.id;
	script.src = options.src;
	script.type = options.type || "text/javascript";
	script.async = options.async || true;
	script.onload  = options.onload;

	const place = options.place || document.body; 
	place.appendChild( script );
}

export const IsSupportsSmoothScroll = () => 'scrollBehavior' in document.documentElement.style; 

export const backToTopSmooth = () => { 
	IsSupportsSmoothScroll()
		? window.scrollTo({ top: 0, behavior: 'smooth' })
		: window.scrollTop = 0;
}


export const fieldsValidation = fields => {
	
	const errors = {};
	let success = true;

	const getError = ( type, value ) => {
		switch ( type ) {
			
			case "required": return !value && "field_is_required";

			case "email": return !/^[a-zA-Z0-9-_+.]+@[a-zA-Z-_.0-9]{2,}\.[a-zA-Z]{2,4}$/.test( value ) && "incorrect_email_format";

			case "method": return !value && "please_select_the_method_of_booking_confirmation";

			case "phone": return !/^\d{9}$/.test( value ) && "invalid_phone_number";

			case "acceptance": return !value && "acceptance_is_required";

		}
	}

	fields.forEach( field => {
		
		const { type, name, value } = field;
		const error = getError( type, value );
		
		if ( error ) {
			errors[ name ] = error;
			success = false;
		}
	});

	return { success, errors };
}


const getRegulationTitle = title => title ? `<div class="heading"> ${ title } </div>` : "";


export const getFullRegulationHTML = regulation_obj => {

	const { title, text } = regulation_obj;

	const textFormatted = 
		regulation_obj.textFormatted 
			? regulation_obj.textFormatted.length > 1
				? regulation_obj.textFormatted.reduce(( total, current ) => {
					total = [...total, ...current ]
					return total;
				}, [])
				: regulation_obj.textFormatted[0]
			: null 

	if ( !text && !textFormatted ) return "";		

	return textFormatted
		? getTextFormattedHTML( textFormatted, title )
		: getRegulationTitle( title ) + text.replace(/\n/gi, "<br>");
}


export const getTextFormattedHTML = ( formatted_text, title, start_level ) => {

	const parseLevel = ( arr, level ) => {

		let html = "";

		arr.forEach( item => {

			if ( Array.isArray( item )) {
				html += parseLevel( item, level + 1 );
			} else {

				switch ( level ) {
					case 1:
						html += `<div style="font-size: 1.42em; font-weight: bold; margin: 30px 0"> ${ item } </div>`;
						break;

					case 2:
						html += `<div style="margin: 13px 0"> ${ item } </div>`;
						break;
						
					case 3: 
						const disc = ( /^\d/.test( item ) || /^\w[.)]/.test( item )) ? "" : "● ";
						html += `<div style="padding-left: 15px; margin-bottom: 9px"> ${ disc } ${ item } </div>`;
						break;	
				}
			}
		});

		return html;
	}	


	const parseLinks = html => {

		const links_mathes = html.match(/<a>[^<>]+<\/>[^<>]+<\/a>/gi);
	
		if ( links_mathes ) {

			links_mathes.forEach( match => {
				const [ link, label ] = match.replace(/<\/?a>/g, "").split("</>");
				html = html.replace( match, `<a href="${link}" target="_blank"> ${ label } </a>`);
			})
		}

		return html;
	}

	return getRegulationTitle( title ) + ( parseLinks( parseLevel( formatted_text, start_level || 1 )));
}

export const cutText = ( text, size ) => {
	if ( text.length <= size ) return text;
	return text.slice( 0, size - 3 ) + "...";
}

export const toggleArrValue = ( value, arr ) => {
	return arr.includes( value )
		? arr.filter( v => v !== value )
		: [...arr, value ]
}

export const filterArrByRegExp = ( arr, search_str, param_name = "" ) => {
	return arr.filter( i => {
		
		const item = param_name ? i[ param_name ] : i;

		const reg_exp = new RegExp( search_str.trim().replace(/[-\/\\^$*+?.()|[\]{}]/gi, "\\$&" ), "gi" )
		return reg_exp.test( item )
	})
}